if (!customElements.get('custom-tattoo-cro')) {
  customElements.define('custom-tattoo-cro', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.start = () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, {once:true});
      else this.initialize();
    }
    initialize() {
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.cards = Array.from(this.querySelectorAll('[data-cro-variant]'));
      this.variantInput = this.form.querySelector('input[name="id"]');
      this.status = this.querySelector('[data-cro-status]');
      this.packProperty = document.createElement('input');
      this.packProperty.type = 'hidden';
      this.packProperty.name = 'properties[' + this.dataset.packLabel + ']';
      this.form.append(this.packProperty);
      this.addEventListener('click', event => {
        const size = event.target.closest('[data-cro-size]');
        const pack = event.target.closest('[data-cro-variant]');
        const upgrade = event.target.closest('[data-cro-upgrade]');
        if (size) {
          const sameCount = this.cards.find(card => card.dataset.size === size.dataset.croSize && card.dataset.count === this.selected?.dataset.count && !card.disabled);
          this.select(sameCount || this.cards.find(card => card.dataset.size === size.dataset.croSize && !card.disabled));
        } else if (pack) this.select(pack);
        else if (upgrade) this.select(this.cards.find(card => card.dataset.croVariant === upgrade.dataset.croUpgrade));
      });
      const initial = this.cards.find(card => card.dataset.croVariant === this.dataset.initialId);
      this.select(initial || this.cards.find(card => !card.disabled), false);
      this.querySelectorAll('.custom-cro-fieldset').forEach(fieldset => {fieldset.disabled = false;});
      this.guard = event => {
        if (event.type === 'submit' && event.target !== this.form) return;
        if (event.type === 'click') {
          const button = event.target.closest('button[type="submit"],input[type="submit"]');
          if (!button || button.form !== this.form) return;
        }
        this.submitAttempted = true;
        const error = this.validationError();
        if (!error) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showStatus(error, false);
        this.status.focus({preventScroll:true});
        this.status.scrollIntoView({block:'center',behavior:'smooth'});
      };
      document.addEventListener('click', this.guard, true);
      document.addEventListener('submit', this.guard, true);
      this.uploadObserver = new MutationObserver(() => this.updateUploadStatus());
      this.uploadObserver.observe(this.form,{childList:true,subtree:true,attributes:true,attributeFilter:['data-filepond-item-state','value']});
      this.updateUploadStatus();
      const faq = this.closest('main')?.querySelector('[id$="__faq_DDwG7d"] .faq-text-sec');
      if (faq) {
        const restoreFaq = () => {
          if (faq.hasAttribute('data-spectrum-removed') && faq.style.getPropertyValue('display') === 'none') faq.style.removeProperty('display');
        };
        this.faqObserver = new MutationObserver(restoreFaq);
        this.faqObserver.observe(faq, {attributes:true,attributeFilter:['style','data-spectrum-removed']});
        restoreFaq();
      }
    }
    select(card, updateUrl = true) {
      if (!card) return;
      this.selected = card;
      this.cards.forEach(item => item.setAttribute('aria-pressed', String(item === card)));
      this.querySelectorAll('[data-cro-size]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.croSize === card.dataset.size)));
      this.querySelectorAll('[data-cro-group]').forEach(group => {group.hidden = group.dataset.croGroup !== card.dataset.size;});
      const bulk = card.closest('details');
      if (bulk) bulk.open = true;
      this.querySelectorAll('[data-cro-upgrade]').forEach(item => {item.hidden = item.dataset.croFrom !== card.dataset.croVariant;});
      this.variantInput.disabled = false;
      this.variantInput.value = card.dataset.croVariant;
      this.packProperty.value = card.dataset.summary;
      this.form.querySelectorAll('button[type="submit"]').forEach(button => {button.disabled = card.disabled;});
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', card.dataset.croVariant);
        history.replaceState({}, '', url);
      }
      const gallery = this.closest('section').querySelector('product-gallery');
      const media = gallery?.querySelector('[data-media-id="' + card.dataset.mediaId + '"]');
      const carousel = gallery?.querySelector('scroll-carousel');
      const first = carousel?.querySelector('.product-gallery__media');
      if (media && carousel && first && updateUrl) carousel.scrollTo({left:media.offsetLeft-first.offsetLeft,behavior:'smooth'});
    }
    uploadState() {
      const items = Array.from(this.form.querySelectorAll('.filepond--item'));
      if (!items.length) return 'empty';
      if (items.some(item => (item.dataset.filepondItemState || '').includes('error'))) return 'error';
      if (items.some(item => !(item.dataset.filepondItemState || '').includes('processing-complete'))) return 'busy';
      const property = this.form.querySelector('input[name="properties[upload]"]');
      return property && property.value.trim() && !property.disabled ? 'ready' : 'busy';
    }
    validationError() {
      if (!this.selected || this.selected.disabled || this.variantInput.value !== this.selected.dataset.croVariant) return this.dataset.unavailable;
      const state = this.uploadState();
      return state === 'ready' ? '' : state === 'empty' ? this.dataset.required : state === 'error' ? this.dataset.uploadError : this.dataset.busy;
    }
    showStatus(message, ready) {
      if (this.status.hidden) this.status.hidden = false;
      if (this.status.dataset.ready !== String(ready)) this.status.dataset.ready = String(ready);
      if (this.status.textContent !== message) this.status.textContent = message;
    }
    updateUploadLabels() {
      const heading = this.form.querySelector('.cl-upload--wrapper > .cl-upload--label');
      const chooser = this.form.querySelector('.filepond--drop-label label');
      if (heading && this.dataset.uploadLabel && heading.textContent !== this.dataset.uploadLabel) heading.textContent = this.dataset.uploadLabel;
      if (chooser && this.dataset.chooseDesign && chooser.textContent !== this.dataset.chooseDesign) chooser.textContent = this.dataset.chooseDesign;
    }
    placeUploadField() {
      const slot = this.querySelector('[data-cro-upload-slot]');
      const wrapper = this.form.querySelector('.cl-upload--wrapper');
      const upload = wrapper?.closest('.upload-container') || wrapper;
      if (slot && upload && !slot.contains(upload)) slot.append(upload);
      const notes = wrapper?.querySelector('.cl-upload--input-fields');
      if (notes && !notes.closest('[data-cro-notes]')) {
        let details = wrapper.querySelector('[data-cro-notes]');
        if (!details) {
          details = document.createElement('details');
          details.dataset.croNotes = '';
          details.className = 'custom-cro-notes';
          const summary = document.createElement('summary');
          summary.textContent = this.dataset.notesLabel;
          details.append(summary);
          wrapper.append(details);
        }
        details.append(notes);
      }
    }
    updateUploadStatus() {
      this.placeUploadField();
      this.updateUploadLabels();
      const state = this.uploadState();
      if (state === 'ready') this.showStatus(this.dataset.ready, true);
      else if (state === 'busy') this.showStatus(this.dataset.busy, false);
      else if (state === 'error') this.showStatus(this.dataset.uploadError, false);
      else if (this.submitAttempted) this.showStatus(this.dataset.required, false);
      else if (!this.status.hidden) this.status.hidden = true;
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded',this.start);
      document.removeEventListener('click',this.guard,true);
      document.removeEventListener('submit',this.guard,true);
      this.uploadObserver?.disconnect();
      this.faqObserver?.disconnect();
    }
  });
}



